import 'twin.macro';
import QualityIcon from '../../assets/svgs/quality-icon.svg';
// Compact "quality" pill shown under the counter/timer during performance: a
// target icon plus the live score rendered as a percentage. Styled to match the
// counter/timer overlay pills (same dark translucent background).
const QualityChip = ({ score, hasScore = true }) => {
  // hasScore=false is REP_BASED at 0 completed reps: nothing has been scored
  // yet, so "--" reads as "no data" instead of a misleadingly literal "0%".
  const value = hasScore && typeof score === 'number' ? Math.round(score) : null;

  return (
    <div
      tw="flex w-fit items-center justify-between gap-4 rounded-[12px] px-[18px] py-[20px] text-white"
      style={{ background: 'rgba(24, 24, 24, 0.5)' }}
    >
      {/* Fixed box, not w-[25%]: a percentage of the chip width made the icon
          resize every time the score gained or lost a digit. */}
      <img src={QualityIcon} alt="Quality" tw="h-[31px] w-[31px] shrink-0" />
      <p tw="flex items-baseline gap-1.5 leading-none">
        {/* 3ch + tabular-nums keeps 0 / 50 / 100 the same width. */}
        <span tw="min-w-[3ch] text-right text-[26px] font-bold tabular-nums">{value ?? '-'}</span>
        <span tw="text-[18px] font-semibold">%</span>
      </p>
    </div>
  );
};

export default QualityChip;
